// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Header-module-header {
  padding: 10px 15px;
  display: flex;
  gap: 15px;
  height: 60px;
  box-sizing: border-box;
  transition: 0.3s;
  align-items: center;
  flex-shrink: 0;
}

#Header-module-backButton, #Header-module-sidebarButtonToggle {
  width: 40px;
  height: 40px;
  padding: 0;
}

#Header-module-sidebarButtonToggle, #Header-module-homeButton, #Header-module-scopeButton {
  display: none;
}

#Header-module-pageName {
  font-size: 1.5rem;
}

@media screen and (min-width: 400px) {

  #Header-module-backButton, #Header-module-pageName {
    display: none;
  }

  #Header-module-sidebarButtonToggle {
    display: flex;
  }
  
  #Header-module-homeButton {
    font-size: 1.5rem;
    font-weight: bold;
    padding: 0;
    background-color: var(--body-background);
    border: none;
    box-shadow: none;
    color: var(--text);
    display: flex;
    border-radius: 5px;
    padding: 0 5px;
    margin: 0 -5px;
    transition: 0.15s;
  }

  #Header-module-homeButton:hover {
    filter: brightness(0.9);
  }

  #Header-module-header {
    border-bottom: 1px solid var(--border);
  }
  
  #Header-module-scopeButton {
    background-color: var(--secondary-button-background);
    color: var(--text);
    display: flex;
    gap: 10px;
    align-items: center;
  }

  #Header-module-scopeButton > svg {
    width: 20px;
    height: 20px;
    fill: var(--text);
  }

}

@media (prefers-color-scheme: dark) {
  
  :root {
    --header: rgb(8, 8, 8);
  }

}

@media print {

  #Header-module-header {
    display: none;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,wCAAwC;IACxC,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oDAAoD;IACpD,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;AAEF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;AAEF","sourcesContent":["#header {\r\n  padding: 10px 15px;\r\n  display: flex;\r\n  gap: 15px;\r\n  height: 60px;\r\n  box-sizing: border-box;\r\n  transition: 0.3s;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n#backButton, #sidebarButtonToggle {\r\n  width: 40px;\r\n  height: 40px;\r\n  padding: 0;\r\n}\r\n\r\n#sidebarButtonToggle, #homeButton, #scopeButton {\r\n  display: none;\r\n}\r\n\r\n#pageName {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n@media screen and (min-width: 400px) {\r\n\r\n  #backButton, #pageName {\r\n    display: none;\r\n  }\r\n\r\n  #sidebarButtonToggle {\r\n    display: flex;\r\n  }\r\n  \r\n  #homeButton {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    padding: 0;\r\n    background-color: var(--body-background);\r\n    border: none;\r\n    box-shadow: none;\r\n    color: var(--text);\r\n    display: flex;\r\n    border-radius: 5px;\r\n    padding: 0 5px;\r\n    margin: 0 -5px;\r\n    transition: 0.15s;\r\n  }\r\n\r\n  #homeButton:hover {\r\n    filter: brightness(0.9);\r\n  }\r\n\r\n  #header {\r\n    border-bottom: 1px solid var(--border);\r\n  }\r\n  \r\n  #scopeButton {\r\n    background-color: var(--secondary-button-background);\r\n    color: var(--text);\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n  }\r\n\r\n  #scopeButton > svg {\r\n    width: 20px;\r\n    height: 20px;\r\n    fill: var(--text);\r\n  }\r\n\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  \r\n  :root {\r\n    --header: rgb(8, 8, 8);\r\n  }\r\n\r\n}\r\n\r\n@media print {\r\n\r\n  #header {\r\n    display: none;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var header = `Header-module-header`;
export var backButton = `Header-module-backButton`;
export var sidebarButtonToggle = `Header-module-sidebarButtonToggle`;
export var homeButton = `Header-module-homeButton`;
export var scopeButton = `Header-module-scopeButton`;
export var pageName = `Header-module-pageName`;
export default ___CSS_LOADER_EXPORT___;
